import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/VersionSwitch/ContextMenu.tsx";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { ContextMenuItem } from "../../classifier-editor/ContextMenuItem";
import { MenuLayout } from "../../classifier-editor/ClassifierTree/TreeContextMenu/MenuLayout";
import { jsx as _jsx } from "react/jsx-runtime";
//TODO перенести в common
export function useContextMenu(menuItems) {
  var _React$useState = React.useState({
    coords: null,
    item: null
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      ctxMenu = _React$useState2[0],
      setCtxMenu = _React$useState2[1];

  var onClose = React.useCallback(function () {
    setCtxMenu({
      coords: null,
      item: null
    });
  }, []);
  var ContextMenu = React.useMemo(function () {
    var ContextMenu = function ContextMenu() {
      if (!ctxMenu.item) {
        return null;
      }

      if (menuItems.every(function (item) {
        return item.show && !item.show(ctxMenu.item);
      })) {
        return null;
      }

      return /*#__PURE__*/_jsx(MenuLayout, {
        onClose: onClose,
        coords: ctxMenu.coords,
        children: menuItems.map(function (_ref, idx) {
          var show = _ref.show,
              title = _ref.title,
              _onClick = _ref.onClick,
              icon = _ref.icon,
              customIcon = _ref.customIcon,
              disabled = _ref.disabled,
              tooltipTitle = _ref.tooltipTitle,
              dataTestId = _ref.dataTestId;

          if (show && !show(ctxMenu.item)) {
            return;
          }

          return /*#__PURE__*/_jsx(ContextMenuItem // eslint-disable-next-line react/no-array-index-key
          , {
            icon: icon,
            customIcon: customIcon,
            "data-test-type": "menuItem",
            "data-test-id": dataTestId,
            onClick: function onClick() {
              ctxMenu.item && _onClick(ctxMenu.item);
              onClose();
            },
            tooltipTitle: ctxMenu.item && tooltipTitle && tooltipTitle(ctxMenu.item),
            disabled: !!(disabled && ctxMenu.item && disabled(ctxMenu.item)),
            children: title
          }, idx);
        })
      });
    };

    return ContextMenu;
  }, [ctxMenu.coords, ctxMenu.item, menuItems, onClose]);
  return {
    ContextMenu: ContextMenu,
    setCtxMenu: setCtxMenu,
    ctxMenu: ctxMenu
  };
}